import { Accordion  } from 'primereact/accordion'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';


import { Button } from 'primereact/button'
import { FaCopy } from 'react-icons/fa'
import ViewEstimating from '../../ESTIMATING/ViewEstimating'
import VIEW_PM_TEMPLATE from '../../PM TEMPLATE/VIEW_PM_TEMPLATE'
import VIEW_INTERIOR_DESIGN from '../../INTERIOR DESIGN TEMPLATE/VIEW_INTERIOR_DESIGN'
import { Api } from '../../../../services/api';
import EDIT_DEVELOPMENT_MANAGER_TEMPLATE from '../../DEVELOPMENT MANAGER TEMPLATE/VIEW_DEVELOPMENT_MANAGER_TEMPLATE';
import VIEW_DEVELOPMENT_MANAGER_TEMPLATE from '../../DEVELOPMENT MANAGER TEMPLATE/VIEW_DEVELOPMENT_MANAGER_TEMPLATE';
import VIEW_JOB_AUTOPSY from '../../JOB AUTOPSY/VIEW_JOB_AUTOPSY';
import VIEW_WARRANTY from '../../WARRANTY/VIEW_WARRANTY';
import { TabView, TabPanel } from 'primereact/tabview';

const HistoryList = () => {
   const { projectId } = useParams();
   const { archiveId } = useParams();
   const [projectName, setProjectName] = useState('');
   useEffect(() => {
      // setIsLoading(false);
      getProjectDetails();


      return () => {
         // Cleanup tasks before the component is unmounted
      };
   }, []);

   const getProjectDetails = () => {
      // fetch.
      var user_id = localStorage.getItem('user_id');
      var role_id = localStorage.getItem('role_id');
      var _body = {
         userId: user_id,
         role_id: role_id,
      }
      fetch(Api.API_BASE_URL + 'template/get-project-for-template', {
         method: "POST",

         body: JSON.stringify(_body),
      })
         .then((response) => response.json())
         .then((response) => {
            // setIsLoading(false);

            response.result.map((e) => {
               if (e.id == projectId) {
                  setProjectName(e.project_name);
               }
            });


         })
         .catch((error) => {
            // setIsLoading(false);
            console.error("Error:", error);
         });
   }

   return (
      <>
          <div className="cardd p-2" style={{ maxWidth: 'auto', minHeight: '85vh', margin:0,  border:'none',}} >
            <div className='m-4 flex one-line-container' >
               <div  >
                  Project Address:  <strong>{projectName}</strong>
               </div>
              
            </div>

            <TabView  >
               <TabPanel  header="DEVELOPMENT PLAYBOOK" className="accordian-header m-2">
                  <VIEW_DEVELOPMENT_MANAGER_TEMPLATE projectId={projectId} archiveId={archiveId}/>
               </TabPanel >

               <TabPanel  header="PRE-CONSTRUCTION PLAYBOOK" className="accordian-header m-2">
                  <ViewEstimating projectId={projectId} archiveId={archiveId}/>
               </TabPanel >

               <TabPanel  header="CONSTRUCTION PLAYBOOK" className="accordian-header m-2">
                  <VIEW_PM_TEMPLATE projectId={projectId} archiveId={archiveId}/>
               </TabPanel >

               <TabPanel  header="INTERIOR DESIGN PLAYBOOK" className="accordian-header m-2">
                  <VIEW_INTERIOR_DESIGN projectId={projectId} archiveId={archiveId} />
               </TabPanel >

               <TabPanel  header="JOB AUTOPSY PLAYBOOK" className="accordian-header m-2">
                  <VIEW_JOB_AUTOPSY projectId={projectId} archiveId={archiveId} />
               </TabPanel >

               <TabPanel  header="WARRANTY PLAYBOOK" className="accordian-header m-2">
                  <VIEW_WARRANTY  projectId={projectId} archiveId={archiveId} />
               </TabPanel >

            </TabView>
         </div>

      </>
   )
}

export default HistoryList